/**
 * Copyright 2025 Paion Data. All rights reserved.
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

void i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        Home: "Home",
        Projects: "Projects",
        Contact: "Contact",
        "Let's Connect": "Let's Connect",

        "Inspiring Your Journey": "Inspiring Your Journey",
        "Welcome to China!": "Welcome to China!",
        "Campaign message":
          "Embark on a transformative journey with our Study Tour - immerse yourself in a new Chinese culture, gain hands-on experience in your field, and expand your academic horizons beyond the classroom. Explore iconic beautiful Chinese landmarks, meet industry experts, and network with peers from around the world. Elevate your learning and broaden your perspective with a study tour designed to ignite your curiosity and empower your future!",

        "Touring Projects": "Touring Projects",
        "Projects campaign message":
          "Embark on an enriching journey through the vibrant tapestry of Chinese culture with our diverse study tour programs! Explore ancient wonders like the Forbidden City, immerse yourself in bustling modern cities like Shanghai, and delve deep into traditional practices in rural villages. Whether you are passionate about language immersion, historical exploration, or contemporary arts, our curated itineraries offer a unique blend of academic insights and authentic experiences, providing an unparalleled opportunity to learn, connect, and discover the true essence of China.",
        Locations: "Locations",
        "Our Clients": "Our Clients",

        Beijing: "Beijing",
        Guilin: "Guilin",
        Shenzhen: "Shenzhen",
        "Xi'an": "Xi'an",
        Suzhou: "Suzhou",
        Chongqing: "Chongqing",
        Xiamen: "Xiamen",
        Changsha: "Changsha",
        "Culture & Religion": "Culture & Religion",
        "Economic Views": "Economic Views",
        Technology: "Technology",
        "Living in Guangxi": "Living in Guangxi",
        "Culture & Food": "Culture & Food",

        "Get In Touch": "Get In Touch",
        "First Name": "First Name",
        "Last Name": "Last Name",
        Email: "Email",
        Message: "Message",
        Send: "Send",
        "Message Sent Successfully!": "Message Sent Successfully!",
        "Thank you for your interests! We will be contacting you shortly.":
          "Thank you for your interests! We will be contacting you shortly.",

        Copyright: "Copyright",
        "All Rights Reserved": "All Rights Reserved",
      },
    },

    zh: {
      translation: {
        Home: "主页",
        Projects: "游学项目",
        Contact: "联系我们",
        "Let's Connect": "开始游学",
        "Inspiring Your Journey": "点亮你的未来",
        "Welcome to China!": "中国欢迎您！",
        "Campaign message":
          "与我们的游学之旅一起踏上激动人心的体验 - 让自己沉浸在现代中国文化中，获得宝贵的阅历，并拓展课堂之外的学术视野。探索中国地标，会见行业专家，并与来自世界各地的小伙伴交流。激发您的好奇心并赋能您的未来的游学之旅，提升您的学习水平并拓宽您的视野！",

        "Touring Projects": "游学项目",
        "Projects campaign message":
          "通过我们丰富多彩的游学项目，踏上丰富多彩的中国文化之旅！探索紫禁城等古老奇观，沉浸在上海等繁华的现代城市，深入研究乡村的传统习俗。无论您热衷于语言沉浸、历史探索还是当代艺术，我们精心策划的行程都将学术和生活独特地融合在一起，为您提供无与伦比的机会来学习、体会和发现中国的真正魅力。",
        Locations: "城市",
        "Our Clients": "我们的游学小伙伴",

        Beijing: "北京",
        Guilin: "桂林",
        Shenzhen: "深圳",
        "Xi'an": "西安",
        Suzhou: "苏州",
        Chongqing: "重庆",
        Xiamen: "厦门",
        Changsha: "长沙",
        "Culture & Religion": "文化 & 宗教",
        "Economic Views": "金融中心",
        Technology: "科技",
        "Living in Guangxi": "桂林生活",
        "Culture & Food": "文化 & 美食",

        "Get In Touch": "联系我们",
        "First Name": "姓",
        "Last Name": "名",
        Email: "邮箱",
        Message: "留言",
        Send: "发送",
        "Message Sent Successfully!": "留言发送成功！",
        "Thank you for your interests! We will be contacting you shortly.": "感谢您的留言，我们将在稍后联系您",

        Copyright: "版权",
        "All Rights Reserved": "版权所有",
      },
    },
    bg: {
      translation: {
        Home: "Начална страница",
        Projects: "проекти",
        Contact: "Контакт",
        "Let's Connect": "Да се свържем",
        "Inspiring Your Journey": "Вдъхновяващо вашето пътуване",
        "Welcome to China!": "добре дошли в Китай!",
        "Campaign message":
          "Впуснете се в преобразяващо пътешествие с нашата учебна обиколка - потопете се в нова китайска култура, придобийте практически опит във вашата област и разширете академичните си хоризонти отвъд класната стая. Разгледайте емблематични красиви китайски забележителности, срещнете се с експерти от индустрията и общувайте с колеги от цял ​​свят. Подобрете обучението си и разширете перспективата си с учебно пътуване, предназначено да разпали любопитството ви и да даде възможност на бъдещето ви!",

        "Touring Projects": "Туристически проекти",
        "Projects campaign message":
          "Впуснете се в едно обогатяващо пътешествие през живия гоблен на китайската култура с нашите разнообразни програми за учебни пътувания! Изследвайте древни чудеса като Забранения град, потопете се в оживени модерни градове като Шанхай и се задълбочете в традиционните практики в селските села. Независимо дали сте запалени по езиковото потапяне, историческото изследване или съвременните изкуства, нашите курирани маршрути предлагат уникална комбинация от академични прозрения и автентични преживявания, предоставяйки несравнима възможност да научите, да се свържете и да откриете истинската същност на Китай.",
        Locations: "Местоположения",
        "Our Clients": "нашите клиенти",

        Beijing: "Пекин",
        Guilin: "Гуилин",
        Shenzhen: "Шенжен",
        "Xi'an": "Сиан",
        Suzhou: "Суджоу",
        Chongqing: "Чунцин",
        Xiamen: "Ксиамен",
        Changsha: "Чанша",
        "Culture & Religion": "Култура и религия",
        "Economic Views": "Икономически възгледи",
        Technology: "технология",
        "Living in Guangxi": "Животът на Гуилин",
        "Culture & Food": "Култура и храна",

        "Get In Touch": "Свържете се с нас",
        "First Name": "Първо име",
        "Last Name": "Фамилия",
        Email: "Имейл",
        Message: "Съобщение",
        Send: "Изпратете",
        "Message Sent Successfully!": "Съобщението е изпратено успешно!",
        "Thank you for your interests! We will be contacting you shortly.":
          "Благодарим ви за проявения интерес! Скоро ще се свържем с вас.",

        Copyright: "Авторско право",
        "All Rights Reserved": "Всички права запазени",
      },
    },
  },
  lng: "en",
  fallbackLng: "en",

  interpolation: {
    escapeValue: false,
  },
});
export default i18n;
